module.exports = __webpack_public_path__ + "static/media/bin.aa7aadd0.svg";